import { render, staticRenderFns } from "./CobranzaPagos.vue?vue&type=template&id=6d35d696&"
import script from "./CobranzaPagos.vue?vue&type=script&lang=js&"
export * from "./CobranzaPagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports